import React, { useState } from 'react';
import { Box, Button, Typography, Container } from '@mui/material';
import ConcurrencyLimitDialog from '../components/ConcurrencyLimitDialog';

const ConcurrencyTestingPanel: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [mode, setMode] = useState<'reuse' | 'reject' | 'allow'>('reuse');

  const showDialog = (selectedMode: 'reuse' | 'reject' | 'allow') => {
    setMode(selectedMode);
    setDialogOpen(true);
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom align="center">
        🔧 并发控制测试面板 | Concurrency Control Testing Panel
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 4 }} align="center">
        测试并发限制对话框的不同模式和行为 | Test different modes and behaviors of concurrency limit dialog
      </Typography>

      {dialogOpen && (
        <Box textAlign="center" mb={2}>
          <Button 
            variant="outlined" 
            color="secondary" 
            onClick={() => setDialogOpen(false)}
            size="small"
          >
            关闭演示 | Close Demo
          </Button>
        </Box>
      )}

      <Box display="flex" gap={2} justifyContent="center" flexWrap="wrap">
        <Button 
          variant="contained" 
          color="info"
          onClick={() => showDialog('reuse')}
        >
          🔄 Reuse Mode
        </Button>
        <Button 
          variant="contained" 
          color="error"
          onClick={() => showDialog('reject')}
        >
          🚫 Reject Mode
        </Button>
        <Button 
          variant="contained" 
          color="warning"
          onClick={() => showDialog('allow')}
        >
          ✅ Allow Mode
        </Button>
      </Box>

      <ConcurrencyLimitDialog
        open={dialogOpen}
        onClose={() => {}} // 演示：不提供关闭功能
        onAttach={() => {
          alert('附着到测试成功！ | Attached to test successfully!');
          setDialogOpen(false);
        }}
        maxActiveRuns={1}
        activeRunId="demo-run-12345"
        mode={mode}
      />
    </Container>
  );
};

export default ConcurrencyTestingPanel;
